module.exports = __webpack_public_path__ + "img/P01-il2015015-005.05f484d8.jpg";